import { ArrowLeft } from "../../../../../shared/components/icons";
import { Button, Form, Container, Row } from "react-bootstrap";
import InputPhone from "../../../../../shared/components/form-elements/input-phone";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { emailPattern, noSpecialCharacter, phoneAndEmailPattern } from "../../../../../shared/regex";
import Api from "../../../../../shared/network/axiosClients";

const NewLeadDetails = ({ onNext, onBack }) => {
  const { t } = useTranslation();
  const {
    control,
    register,
    formState: { errors },
    handleSubmit
  } = useForm();
  const form = useForm();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);


  const onSubmit = async (data) => {
    setLoading(true); // Set loading to true before starting the API call
    // Create the object to send to the API
    const payload = {
      name: data.name,
      contactNumber: data.contactNumber,
      email: data.email?.trim(), // Include email if not empty or whitespace
    };

    // Remove the email key if it is empty or whitespace
    if (!payload.email) {
      delete payload.email;
    }

    try {
      const response = await Api.post("web-leads/solar", payload);
      if (response.status === 201) {
        onNext?.();
      } else {
        setErrorMessage(t("common_error_message"));
      }
    } catch (error) {
      setErrorMessage(t("submission_error_message"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="heroBanner-pa pt-4">
      <section className="my-health-takaful-bnr mt-4">
        <Container className="text-center px-4 px-md-0 justify-content-center mb-4">
          <Row className="d-grid justify-content-center">
          <h1 className="solarheadingH1">{t("solar_heading_solar_panel")} <span> {t("solar_heading_insurance")}</span></h1>
          <h3 className="solarheadingH3 mx-2 mx-md-0">{t("solar_subHeading")}</h3>
          </Row>
        </Container>
        <Container className="text-center px-4 px-md-0 justify-content-center">
          <Row className="d-grid justify-content-center">
            <div className="d-flex justify-content-center mb-md-4">
              <a
                className="hwb-back mt-1 me-4"
                data-testid="lead-details-form-back"
                onClick={onBack}
              >
                <ArrowLeft />
              </a>
              <h1 className="mb-4 mb-md-3">{t("please_provide_details")}</h1>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group
                className="floating-input mb-4"
                data-testid="lead_details_name"
              >
                <Form.Control
                  id="name"
                  // className={!errors?.name && dirtyFields?.name ? "is-valid" : ""}
                  type="text"
                  placeholder=""
                  {...register("name", {
                    required: t("health_landing_user_details_lead_form_name_required_error"),
                    maxLength: {
                      value: 35,
                      message: t("health_landing_user_details_lead_form_name_max_error")
                    },
                    pattern: {
                      value: noSpecialCharacter,
                      message: t("health_landing_user_details_lead_form_name_special_character_error")
                    }
                  })}
                />
                <Form.Label htmlFor="name">
                  {t("name")}
                  <span>{t("required_symbol")}</span>
                </Form.Label>
                <div className={"text-start text-primary fs-12px hide-empty mt-1"}>{errors?.name && <span>{t("solar_lead-details_name_validation")}</span>}</div>
              </Form.Group>
              <Form.Group className="floating-input mb-4">
                <Controller
                  name="contactNumber"
                  control={control}
                  render={({ field }) => (
                    <InputPhone
                      placeholder={t("contact_number_placeholder")}
                      {...field}
                    />
                  )}
                  rules={{
                    required: "Number is required",
                    pattern: {
                      value: phoneAndEmailPattern,
                      message: "Invalid contact number"
                    }
                  }}
                />
                {errors?.contactNumber && (
                  <div className="text-start text-primary fs-12px hide-empty mt-1">{t("sme_lead-details_contact_number_validation")}</div>
                )}
              </Form.Group>

              <Form.Group
                className="floating-input mb-3"
                // data-testid="lead_details_email"
              >
                <Form.Control
                  // className={!errors?.email && dirtyFields?.email ? "is-valid" : ""}
                  id="email"
                  type="text"
                  placeholder=""
                  {...register("email", {
                    // required: t("auth_signup_email_required_error"),
                    pattern: {
                      value: emailPattern,
                      message: t("auth_signup_email_valid_error")
                    }
                  })}
                />
                <Form.Label htmlFor="email">
                  {t("health_landing_user_details_form_lead_email_label")}
                  {/* <span>{t("required_symbol")}</span> */}
                </Form.Label>
                <div className={"text-primary fs-12px hide-empty mt-1"}>{errors?.email && <span>{errors.email.message}</span>}</div>
              </Form.Group>

              <Form.Check
                className="hwb-accept-terms"
                data-testid="lead_details_agree"
                type={"checkbox"}
                {...register("termAndCondition", {
                  required: t("health_landing_user_details_lead_form_terms_required_error")
                })}
                label={
                  <>
                    {t("health_landing_user_details_form_terms_agree")}
                    <a href=" https://takafulbazaar.pk/terms-and-conditions">{t("health_landing_user_details_form_terms_and_condition_agree")}</a>
                  </>
                }
              />
              <div className={"text-start text-primary fs-12px hide-empty mt-1"}>
                {errors?.termAndCondition && <span>{errors.termAndCondition.message}</span>}
              </div>

              {errorMessage && <div className="error-message text-danger mt-3">{errorMessage}</div>}
              <Button
                className="hwb-btn"
                size="lg"
                type="submit"
                disabled={loading} // Disable the button when loading
                // onClick={onNext}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </form>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default NewLeadDetails;
